const userManagement = {
  moduleTitle: "المستخدمون",
  nav: {
    drivers: "السائقين",
  },
  actions: {
    view: "عرض",
    create: "إنشاء",
    update: "تعديل",
    delete: "حذف",
  },
  // NavDrawer.tsx swaps to this key at render time for userType "staff",
  // a presentation-only override that never touches the static nav tree.
  moduleTitleStaff: "إدارة السائقين",
  permissions: {
    core: "النواة",
    userManagement: "إدارة المستخدمين",
    users: "المستخدمون",
    drivers: "السائقين",
  },
  drivers: {
    title: "السائقين",
    stats: {
      label: "إحصائيات السائقين",
      total: "إجمالي السائقين",
      assigned: "السائقون المعيّنون",
      unassigned: "السائقون غير المعيّنين",
      expiredLicenses: "رخص منتهية الصلاحية",
      loading: "جارٍ التحميل",
      error: "غير متاح",
    },
    toolbar: {
      search: "بحث...",
      searchLabel: "ابحث باسم السائق أو رقم الهوية / جواز السفر أو رقم الرخصة",
      filters: "التصفية",
      add: "إضافة سائق",
      archive: "الأرشيف",
    },
    create: {
      breadcrumb: "إضافة سائق",
      title: "إضافة سائق",
      subtitle: "أدخل بيانات السائق الجديد وارفع المستندات المطلوبة",
      back: "العودة إلى السائقين",
      tabs: {
        basicInfo: "المعلومات الأساسية",
        attachments: "المرفقات",
      },
      sections: {
        personal: "المعلومات الشخصية",
        work: "معلومات العمل",
        license: "معلومات رخصة القيادة",
      },
      photo: {
        label: "الصورة الشخصية",
        upload: "تحميل صورة",
        remove: "إزالة الصورة",
        hint: "JPG أو PNG، بحد أقصى 5 ميجابايت",
        invalidType: "يجب أن تكون الصورة الشخصية بصيغة JPG أو PNG.",
        tooLarge: "يجب ألا يتجاوز حجم الصورة الشخصية 5 ميجابايت.",
      },
      fields: {
        optional: "(اختياري)",
        company: "الشركة",
        companyPlaceholder: "اختر الشركة",
        companySearch: "ابحث عن شركة",
        companyEmpty: "لا توجد شركات",
        branch: "الفرع",
        branchPlaceholder: "اختر الفرع",
        branchSearch: "ابحث عن فرع",
        branchEmpty: "لا توجد فروع",
        loading: "جارٍ التحميل",
        nameAr: "الاسم بالعربي",
        nameArPlaceholder: "مثال: احمد محمد احمد",
        nameEn: "الاسم بالانجليزي",
        nameEnPlaceholder: "EX:AHMED MOHAMED AHMED",
        nationalId: "رقم الهوية / جواز السفر",
        username: "اسم المستخدم",
        email: "البريد الإلكتروني",
        rfid: "RFID",
        mobileNumber1: "رقم الهاتف",
        mobileNumber2: "رقم الهاتف",
        countrySelect: "رمز الدولة",
        licenseNumber: "رقم الرخصة",
        licenseIssueDate: "تاريخ الإصدار",
        licenseExpiryDate: "تاريخ انتهاء الرخصة",
        datePlaceholder: "MM/DD/YYYY",
        nextMonth: "الشهر التالي",
        previousMonth: "الشهر السابق",
      },
      countries: {
        ksa: "المملكة العربية السعودية",
        egypt: "مصر",
        uae: "الإمارات العربية المتحدة",
        jordan: "الأردن",
      },
      validation: {
        required: "هذا الحقل مطلوب.",
        minLength: "يجب أن يحتوي هذا الحقل على 4 أحرف على الأقل.",
        maxLength: "يجب ألا يتجاوز هذا الحقل 50 حرفاً.",
        arabicOnly: "يجب أن يحتوي الاسم على أحرف عربية فقط.",
        englishOnly: "يجب أن يحتوي الاسم على أحرف إنجليزية فقط.",
        usernameFormat:
          "يجب أن يبدأ اسم المستخدم بحرف وأن يحتوي فقط على أحرف إنجليزية أو أرقام أو نقاط أو شرطات سفلية أو شرطات.",
        emailInvalid: "يرجى إدخال بريد إلكتروني صحيح.",
        emailLength: "يجب أن يكون البريد الإلكتروني بين 6 و254 حرفاً.",
        phoneInvalid: "يرجى إدخال رقم هاتف صحيح للدولة المحددة.",
        phoneLeadingZero:
          "يجب أن يبدأ رقم الهاتف المصري بصفر (مثال: 01012345678).",
        phoneEgyptLength: "يجب أن يتكون رقم الهاتف المصري من 11 رقمًا بالضبط.",
        phoneSaudiStart:
          "يجب أن يبدأ رقم الهاتف السعودي بالرقم 5 (مثال: 512345678).",
        phoneSaudiLength: "يجب أن يتكون رقم الهاتف السعودي من 9 أرقام بالضبط.",
        phoneLength:
          "يجب أن يحتوي رقم الهاتف على عدد أرقام صحيح للدولة المحددة.",
        minWords:
          "يجب أن يحتوي الاسم على ثلاث كلمات على الأقل (الاسم واسم الأب واسم العائلة).",
        expiryInPast: "يجب أن يكون تاريخ انتهاء الرخصة تاريخاً مستقبلياً.",
        expiryBeforeIssue: "يجب أن يكون تاريخ الانتهاء بعد تاريخ الإصدار.",
      },
      duplicate: {
        username: "المستخدم موجود بالفعل.",
        email: "البريد الإلكتروني موجود بالفعل.",
        nationalId: "رقم الهوية الوطنية موجود بالفعل.",
      },
      attachments: {
        input: "رفع المستندات",
        dropzoneTitle: "اسحب الملفات هنا أو انقر للاستعراض",
        dropzoneHint: "PDF, PNG, JPG بحد أقصى 25 ميجابايت لكل ملف و10 ملفات",
        browse: "استعراض الملفات",
        addMore: "إضافة ملفات أخرى",
        remove: "إزالة {{name}}",
        pending: "بانتظار الرفع",
        invalidType: "يُسمح فقط بملفات PDF وPNG وJPG.",
        tooLarge: "يجب ألا يتجاوز حجم كل ملف 25 ميجابايت.",
        tooMany: "يمكنك رفع 10 ملفات كحد أقصى.",
      },
      cancel: "الغاء",
      save: "حفظ",
      success: "تم إنشاء السائق وإرسال بريد التفعيل إليه.",
      failure: "تعذر إنشاء السائق.",
      restoreDialog: {
        title: "استعادة السائق",
        question: "يوجد سائق بنفس المعلومات في السائقين المؤرشفين.",
        prompt: "هل تريد استعادة هذا السائق؟",
        cancel: "إلغاء",
        confirm: "استعادة السائق",
        close: "إغلاق نافذة الاستعادة",
        success: "تمت استعادة السائق بنجاح.",
        failure: "تعذر استعادة السائق. يرجى المحاولة مرة أخرى.",
      },
      unsavedChanges: {
        title: "تغييرات غير محفوظة",
        message: "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
        stay: "البقاء",
        leave: "مغادرة",
        close: "إغلاق",
      },
    },
    edit: {
      back: "العودة إلى السائقين",
      save: "حفظ التعديلات",
      success: "تم تحديث بيانات السائق بنجاح.",
      failure: "تعذر تحديث بيانات السائق.",
      notAvailable: "غير متوفر",
      fields: {
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
      },
      photo: {
        change: "تغيير الصورة",
      },
      attachments: {
        existing: "المستندات المرفوعة",
        view: "عرض {{name}}",
      },
      statusDialog: {
        activateTitle: "تفعيل السائق",
        deactivateTitle: "إيقاف السائق",
        activate: "هل أنت متأكد أنك تريد تفعيل هذا السائق؟",
        deactivate: "هل أنت متأكد أنك تريد إيقاف هذا السائق؟",
        note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
        yes: "نعم",
        no: "لا",
        close: "إغلاق",
      },
    },
    resendActivation: {
      action: "إعادة إرسال رابط التفعيل",
      title: "إعادة إرسال رابط التفعيل",
      message:
        "سيتم إرسال رابط تفعيل جديد إلى بريد هذا السائق. هل تريد المتابعة؟",
      messageTo: "سيتم إرسال رابط تفعيل جديد إلى {{email}}. هل تريد المتابعة؟",
      cancel: "إلغاء",
      confirm: "إعادة الإرسال",
      close: "إغلاق نافذة إعادة الإرسال",
      success: "تم إرسال رابط التفعيل إلى السائق.",
      failure: "تعذر إرسال رابط التفعيل. يرجى المحاولة مرة أخرى.",
    },
    filters: {
      status: "الحالة",
      allStatuses: "كل الحالات",
      expiryDate: "تاريخ انتهاء الرخصة",
      expiryDatePlaceholder: "اختر نطاقاً زمنياً",
      clearDateRange: "مسح النطاق الزمني",
      reset: "إعادة تعيين التصفية",
    },
    datePicker: {
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
    },
    table: {
      name: "اسم السائق",
      company: "الشركة",
      nationalId: "رقم الهوية / جواز السفر",
      licenseNumber: "رقم الرخصة",
      licenseExpiryDate: "تاريخ انتهاء الرخصة",
      status: "الحالة",
      expired: "منتهية",
      error: "تعذر تحميل السائقين.",
      loading: "جارٍ تحميل السائقين",
      showingCount: "عرض {{count}} من {{total}}",
      rowsPerPageLabel: "عرض الصفوف",
      nextPage: "الصفحة التالية",
      previousPage: "الصفحة السابقة",
      pagination: "ترقيم الصفحات",
      sortAscending: "ترتيب تصاعدي",
      sortDescending: "ترتيب تنازلي",
    },
    empty: {
      noDrivers: "لم يتم إنشاء أي سائقين بعد.",
      noSearchResults: "لا يوجد سائقون مطابقون لبحثك.",
      noFilterResults: "لا يوجد سائق مطابق للتصفية المحددة.",
      clearSearch: "مسح البحث",
    },
    status: {
      active: "نشط",
      inactive: "غير نشط",
      pendingActivation: "بانتظار التفعيل",
    },
    actions: {
      trigger: "إجراءات السائق",
      view: "عرض",
      edit: "تعديل",
      delete: "حذف",
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا السائق؟",
      warning: "سينتقل السائق إلى الأرشيف ويمكن استعادته لاحقاً.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "إلغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      success: "تم حذف السائق ونقله إلى الأرشيف.",
    },
    archived: {
      title: "السائقون المؤرشفون",
      subtitle: "السائقون الذين تمت أرشفتهم ويمكن استعادتهم.",
      back: "العودة إلى السائقين",
      search: "بحث...",
      searchLabel: "ابحث بالاسم أو اسم المستخدم أو البريد الإلكتروني",
      filters: "التصفية",
      archivedAt: "تاريخ الأرشفة",
      archivedAtPlaceholder: "اختر نطاقاً زمنياً",
      clearDateRange: "مسح النطاق الزمني",
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
      empty: "لم يتم العثور على سائقين مؤرشفين.",
      restore: "استعادة {{name}}",
      table: {
        name: "اسم السائق",
        username: "اسم المستخدم",
        company: "الشركة",
        email: "البريد الإلكتروني",
        archivedAt: "تاريخ الأرشفة",
        error: "تعذر تحميل السائقين المؤرشفين.",
        loading: "جارٍ تحميل السائقين المؤرشفين",
      },
      restoreDialog: {
        title: "استعادة السائق",
        question: "هل أنت متأكد أنك تريد استعادة هذا السائق؟",
        prompt: "سيعود السائق إلى قائمة السائقين بنفس الحالة التي كان عليها.",
        cancel: "إلغاء",
        confirm: "استعادة",
        close: "إغلاق نافذة الاستعادة",
        success: "تمت استعادة السائق بنجاح.",
        failure: "تعذر استعادة السائق. يرجى المحاولة مرة أخرى.",
      },
    },
    detail: {
      back: "العودة إلى السائقين",
      edit: "تعديل",
      loading: "جارٍ تحميل بيانات السائق",
      error: "تعذر تحميل بيانات السائق.",
      notFound: "السائق غير موجود.",
      notAvailable: "غير متوفر",
      tabs: {
        basicInfo: "المعلومات الأساسية",
        attachments: "المرفقات",
      },
      profile: "الملف الشخصي",
      accountStatus: "حالة الحساب",
      nationalId: "رقم الهوية / جواز السفر",
      mobileNumber1: "رقم الجوال 1",
      mobileNumber2: "رقم الجوال 2",
      email: "البريد الإلكتروني",
      rfid: "بطاقة RFID",
      license: "معلومات رخصة القيادة",
      licenseNumber: "رقم الرخصة",
      issueDate: "تاريخ الإصدار",
      expiryDate: "تاريخ الانتهاء",
      expired: "منتهية الصلاحية",
      company: "الشركة",
      work: "معلومات العمل",
      branch: "الفرع",
    },
    attachments: {
      empty: "لم يتم رفع أي مستندات.",
      uploadedAt: "تم الرفع في {{date}}",
      view: "عرض {{name}}",
      download: "تنزيل {{name}}",
    },
  },
  users: {
    title: "إدارة المستخدمين",
    subtitle: "إدارة حسابات المستخدمين التشغيليين وربطهم بالأقسام والفروع",
    table: {
      name: "الاسم",
      username: "اسم المستخدم",
      email: "البريد الالكتروني",
      branch: "الفرع",
      department: "القسم",
      status: "الحالة",
      error: "تعذر تحميل المستخدمين.",
      loading: "جارٍ تحميل المستخدمين",
      showingCount: "عرض {{count}} من {{total}}",
      rowsPerPageLabel: "عرض الصفوف",
      nextPage: "الصفحة التالية",
      previousPage: "الصفحة السابقة",
      pagination: "ترقيم الصفحات",
      sortAscending: "ترتيب تصاعدي",
      sortDescending: "ترتيب تنازلي",
    },
    toolbar: {
      searchLabel: "ابحث باسم المستخدم أو اسم الدخول أو البريد الإلكتروني",
      search: "بحث...",
      filters: "التصفية",
      archive: "الأرشيف",
      add: "اضافة مستخدم",
    },
    filters: {
      status: "الحالة",
      allStatuses: "كل الحالات",
      reset: "إعادة تعيين",
    },
    status: {
      active: "نشط",
      inactive: "غير نشط",
      pendingActivation: "قيد التفعيل",
    },
    empty: {
      noSearchResults: "لا توجد نتائج مطابقة لبحثك.",
      clearSearch: "مسح البحث",
      noFilterResults: "لا توجد نتائج مطابقة لهذه التصفية.",
      noUsers: "لا يوجد مستخدمون بعد.",
    },
    actions: {
      trigger: "إجراءات المستخدم",
      view: "عرض",
      edit: "تعديل",
      delete: "حذف",
      resendActivation: "إعادة إرسال التفعيل",
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا المستخدم؟",
      warning: "سينتقل المستخدم إلى الأرشيف ويمكن استعادته لاحقاً.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "إلغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      success: "تم حذف المستخدم ونقله إلى الأرشيف.",
    },
    resendActivationDialog: {
      title: "إعادة إرسال رابط التفعيل؟",
      message: "سيتم إرسال رابط تفعيل جديد إلى البريد الإلكتروني للمستخدم.",
      confirm: "إعادة الإرسال",
      cancel: "إلغاء",
      close: "إغلاق",
    },
    form: {
      sections: {
        basicInfo: "المعلومات الأساسية",
      },
      fields: {
        optional: "(اختياري)",
        nameAr: "الاسم بالعربي",
        nameArPlaceholder: "الاسم ثلاثي",
        nameEn: "الاسم بالانجليزية",
        nameEnPlaceholder: "Full Name",
        email: "البريد الالكتروني",
        emailPlaceholder: "مثال: a.hassan@tracking.sa",
        username: "اسم المستخدم (الدخول)",
        usernamePlaceholder: "مثال: a.hassan",
        mobileNumber1: "رقم الهاتف",
        countrySelect: "رمز الدولة",
        department: "القسم",
        departmentPlaceholder: "اختر القسم",
        departmentSearch: "ابحث عن قسم",
        departmentEmpty: "لا توجد أقسام",
        branch: "الفرع",
        branchPlaceholder: "اختر",
        branchSearch: "ابحث عن فرع",
        branchEmpty: "لا توجد فروع",
        loading: "جارٍ التحميل",
        role: "الصلاحيات",
        rolePlaceholder: "اختر",
        isActive: "نشط",
      },
      countries: {
        ksa: "المملكة العربية السعودية",
        egypt: "مصر",
        uae: "الإمارات العربية المتحدة",
        jordan: "الأردن",
      },
      statusDialog: {
        titleActivate: "تفعيل المستخدم",
        titleDeactivate: "إلغاء تفعيل المستخدم",
        questionActivate: "هل أنت متأكد أنك تريد تفعيل هذا المستخدم؟",
        questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا المستخدم؟",
        note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
        yes: "نعم",
        no: "لا",
        close: "إغلاق نافذة تغيير الحالة",
      },
      cancel: "الغاء",
    },
    create: {
      breadcrumb: "إضافة مستخدم",
      title: "إضافة مستخدم",
      subtitle: "أدخل بيانات المستخدم الجديد",
      back: "العودة إلى إدارة المستخدمين",
      save: "حفظ",
      success: "تم إنشاء المستخدم وإرسال بريد التفعيل إليه.",
      failure: "تعذر إنشاء المستخدم.",
      duplicate: {
        username: "اسم المستخدم موجود بالفعل.",
        email: "البريد الإلكتروني موجود بالفعل.",
      },
      restoreDialog: {
        title: "استعادة المستخدم",
        question: "يوجد مستخدم بنفس المعلومات في المستخدمين المؤرشفين.",
        prompt: "هل تريد استعادة هذا المستخدم؟",
        cancel: "إلغاء",
        confirm: "استعادة المستخدم",
        close: "إغلاق نافذة الاستعادة",
        success: "تمت استعادة المستخدم بنجاح.",
        failure: "تعذر استعادة المستخدم. يرجى المحاولة مرة أخرى.",
      },
    },
    edit: {
      loading: "جارٍ تحميل بيانات المستخدم",
      notAvailable: "تعذر العثور على هذا المستخدم.",
      back: "العودة إلى تفاصيل المستخدم",
      save: "حفظ التعديلات",
      success: "تم تحديث بيانات المستخدم بنجاح.",
      failure: "تعذر تحديث بيانات المستخدم.",
    },
    detail: {
      loading: "جارٍ تحميل بيانات المستخدم",
      error: "تعذر تحميل بيانات المستخدم.",
      notAvailable: "غير متاح",
      back: "العودة إلى إدارة المستخدمين",
      subtitle: "بيانات المستخدم وصلاحياته",
      edit: "تعديل",
      section: "تفاصيل المستخدم",
      name: "الاسم",
      username: "اسم المستخدم",
      email: "البريد الالكتروني",
      mobileNumber1: "رقم الهاتف",
      branch: "الفرع",
      department: "القسم",
    },
    archived: {
      title: "المستخدمون المؤرشفون",
      subtitle: "المستخدمون الذين تمت أرشفتهم ويمكن استعادتهم.",
      back: "العودة إلى إدارة المستخدمين",
      searchLabel: "ابحث بالاسم أو اسم المستخدم أو البريد الإلكتروني",
      search: "بحث...",
      filters: "التصفية",
      archivedAt: "تاريخ الأرشفة",
      archivedAtPlaceholder: "اختر نطاقاً زمنياً",
      clearDateRange: "مسح النطاق الزمني",
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
      empty: "لم يتم العثور على مستخدمين مؤرشفين.",
      restore: "استعادة {{name}}",
      table: {
        name: "اسم المستخدم",
        username: "اسم الدخول",
        email: "البريد الإلكتروني",
        archivedAt: "تاريخ الأرشفة",
        error: "تعذر تحميل المستخدمين المؤرشفين.",
        loading: "جارٍ تحميل المستخدمين المؤرشفين",
      },
      restoreDialog: {
        title: "استعادة المستخدم",
        question: "هل أنت متأكد أنك تريد استعادة هذا المستخدم؟",
        prompt: "سيعود المستخدم إلى القائمة بنفس الحالة التي كان عليها.",
        cancel: "إلغاء",
        confirm: "استعادة",
        close: "إغلاق نافذة الاستعادة",
        success: "تمت استعادة المستخدم بنجاح.",
        failure: "تعذر استعادة المستخدم. يرجى المحاولة مرة أخرى.",
      },
    },
  },
};

export default userManagement;
